import { apiSlice } from "../apiSlice";

const preInvoiceUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/preinvoice`;

export const PreInvoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    // CREATE
    createPreInvoice: builder.mutation({
      query: (invoiceData) => ({
        url: `${preInvoiceUrl}/create`,
        method: "POST",
        body: invoiceData,
      }),
      invalidatesTags: ["preinvoices"],
    }),

    // GET ALL
    getPreInvoices: builder.query({
      query: () => ({
        url: `${preInvoiceUrl}`,
        method: "GET",
      }),
      providesTags: ["preinvoices"],
    }),

    // GET ONE BY ID
    getPreInvoiceById: builder.query({
      query: (billNumber) => ({
        url: `${preInvoiceUrl}/get/${billNumber}`,
        method: "GET",
      }),
      providesTags: ["preinvoices"],
    }),

    // UPDATE
    updatePreInvoice: builder.mutation({
      query: ({ id, data }) => ({
        url: `${preInvoiceUrl}/update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["preinvoices"],
    }),

    // DELETE
    deletePreInvoice: builder.mutation({
      query: (id) => ({
        url: `${preInvoiceUrl}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["preinvoices"],
    }),

  }),
});

// EXPORT HOOKS
export const {
  useCreatePreInvoiceMutation,
  useGetPreInvoicesQuery,
  useGetPreInvoiceByIdQuery,
  useLazyGetPreInvoiceByIdQuery,
  useUpdatePreInvoiceMutation,
  useDeletePreInvoiceMutation,
} = PreInvoiceApiSlice;
